// A agenda da caixa.
//
// Ela se alimenta sozinha: quem você responde entra como contato, com o nome
// que vinha na mensagem. Este arquivo só lê, edita e apaga — a captura é do
// servidor, no momento do envio.

import { api } from "./cliente";
import type { Contato } from "./tipos";

export type { Contato };

// OBJETO, NÃO POSIÇÃO. Com três parâmetros opcionais seguidos, acrescentar
// um no meio desloca os outros em silêncio para quem só passa o primeiro e o
// último — foi o que aconteceu ao acrescentar `grupo`: o
// `CampoDeEnderecos` passava o AbortSignal e ele virou nome de grupo. O
// compilador pegou desta vez; na próxima pode ser um tipo compatível.
export const listar = (
  filtro: { q?: string; grupo?: string } = {},
  sinal?: AbortSignal,
) => api.get<{ itens: Contato[] }>("/contatos", { consulta: filtro, sinal });

// `email` deixou de ser obrigatório: agenda migrada traz contato que só tem
// nome e telefone. O servidor exige ao menos um entre os três.
export const salvar = (dados: Partial<Contato>) =>
  api.post<Contato>("/contatos", dados);

export const alterar = (uuid: string, dados: Partial<Contato>) =>
  api.patch<Contato>(`/contatos/${uuid}`, dados);

export const remover = (uuid: string) => api.delete<void>(`/contatos/${uuid}`);
